import { Link } from "react-router-dom";
import { articles, categories } from "@/mocks/news";

export default function ChannelNav() {
  return (
    <section className="bg-background-100/70 py-10 md:py-14">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex items-end justify-between gap-4 mb-6">
          <div>
            <div className="flex items-center gap-3">
              <span className="w-1.5 h-6 rounded-full bg-accent-500 inline-block"></span>
              <h2 className="font-heading text-xl md:text-2xl font-black text-foreground-950">五大栏目 · 每日更新</h2>
            </div>
            <p className="mt-2 text-sm text-foreground-500">娱乐社会财经科技体育，最新爆料按栏目持续送达</p>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {categories.map((c) => {
            const count = articles.filter((a) => a.category === c.slug).length;
            return (
              <Link
                key={c.slug}
                to={`/category/${c.slug}`}
                className="group relative rounded-lg overflow-hidden h-44 md:h-52"
                aria-label={`${c.name}栏目`}
              >
                <img
                  src={c.cover}
                  alt={`${c.name}栏目最新爆料`}
                  title={`${c.name}爆料栏目 - 每日爆料`}
                  className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/25 to-foreground-950/10"></div>
                <div className="absolute inset-x-0 bottom-0 p-4">
                  <span className="font-heading text-lg font-black text-background-50 group-hover:text-accent-300 transition-colors">
                    {c.name}
                  </span>
                  <p className="mt-1 text-xs text-background-200/90 line-clamp-2">{c.desc}</p>
                  <span className="mt-2 inline-flex items-center gap-1 text-xs text-accent-300">
                    <i className="ri-flashlight-line"></i>{count} 条最新
                  </span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}